import React, { useState, useEffect, useMemo } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCkQzyz7L9purOchKqw6LM8xBJRULISMY8",
    authDomain: "hutang-268e5.firebaseapp.com",
    projectId: "hutang-268e5",
    storageBucket: "hutang-268e5.appspot.com",
    messagingSenderId: "263150301451",
    appId: "1:263150301451:web:18a9197271f8838fccf20e"
};

// Initialize Firebase
if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}
const db = firebase.firestore();
const auth = firebase.auth();

// === Komponen Ikon Sederhana (SVG) ===
const PlusIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" /></svg>
);
const UserGroupIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-blue-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.653-.124-1.282-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.653.124-1.282.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" /></svg>
);
const CurrencyDollarIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v.01M12 6v-1.5M12 9.5v-1.5M12 14.5v-1.5M12 17v-1.5M12 12a2 2 0 100-4 2 2 0 000 4z" /></svg>
);
const ArrowRightIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mx-2 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg>
);
 const LogoutIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" /></svg>
);

// === Komponen Utama Aplikasi (Router) ===
function App() {
    const [user, setUser] = useState(null);
    const [userProfile, setUserProfile] = useState(null);
    const [authCheckComplete, setAuthCheckComplete] = useState(false);

    // Effect to handle authentication state changes
    useEffect(() => {
        const unsub = auth.onAuthStateChanged((user) => {
            setUser(user);
            if (!user) {
                // If user logs out, we can immediately mark the check as complete
                setAuthCheckComplete(true);
            }
        });
        return () => unsub(); // Cleanup auth listener
    }, []);

    // Effect to handle fetching user profile when user object is available
    useEffect(() => {
        // If there's no user, clear the profile and we are done.
        if (!user) {
            setUserProfile(null);
            return;
        }

        // If there is a user, listen to their profile document
        const profileUnsub = db.collection('users').doc(user.uid).onSnapshot((docSnap) => {
            const profile = docSnap.exists ? docSnap.data() : null;
            setUserProfile(profile);
            setAuthCheckComplete(true); // Now we have auth status AND profile status
        }, (error) => {
            console.error("Profile snapshot error:", error);
            setUserProfile(null); // On error, set profile to null
            setAuthCheckComplete(true); // Mark as complete even on error
        });
        
        return () => profileUnsub(); // Cleanup profile listener
    }, [user]);


    if (!authCheckComplete) {
        return <div className="min-h-screen bg-gray-900 flex justify-center items-center text-white">Memuat...</div>;
    }

    if (user && userProfile && userProfile.isSetupComplete) {
        return <Dashboard user={user} userProfile={userProfile} />;
    }

    if (user && (!userProfile || !userProfile.isSetupComplete)) {
        return <SetupScreen user={user} onSetupComplete={(profileUpdate) => setUserProfile(prev => ({...prev, ...profileUpdate}))} />;
    }
    
    return <LoginScreen />;
}

// === Halaman Login & Registrasi ===
function LoginScreen() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isRegister, setIsRegister] = useState(false);
    const [error, setError] = useState('');

    const handleAuth = async (e) => {
        e.preventDefault();
        setError('');
        try {
            await auth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

            if (isRegister) {
                const userCredential = await auth.createUserWithEmailAndPassword(email, password);
                const isSuperAdmin = email === 'superadmin@example.com';
                await db.collection('users').doc(userCredential.user.uid).set({
                    email: userCredential.user.email,
                    role: isSuperAdmin ? 'superadmin' : 'user',
                    isSetupComplete: isSuperAdmin,
                    managedTokoIds: [],
                });
            } else {
                await auth.signInWithEmailAndPassword(email, password);
            }
        } catch (err) {
            setError(err.message);
        }
    };

    return (
         <div className="min-h-screen bg-gray-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-md bg-gray-800 p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold text-cyan-400 mb-6 text-center">{isRegister ? 'Registrasi Akun Baru' : 'Login Aplikasi'}</h1>
                <form onSubmit={handleAuth}>
                    <div className="mb-4">
                        <label className="block text-gray-400 mb-2" htmlFor="email">Email</label>
                        <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500" required />
                    </div>
                    <div className="mb-6">
                        <label className="block text-gray-400 mb-2" htmlFor="password">Password</label>
                        <input type="password" id="password" value={password} onChange={e => setPassword(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-cyan-500" required />
                    </div>
                    {error && <p className="text-red-400 text-center mb-4">{error}</p>}
                    <button type="submit" className="w-full bg-cyan-500 hover:bg-cyan-600 text-white font-bold py-2 px-4 rounded-lg transition-colors">
                        {isRegister ? 'Daftar' : 'Login'}
                    </button>
                </form>
                <p className="text-center text-gray-400 mt-6">
                    {isRegister ? 'Sudah punya akun?' : 'Belum punya akun?'}
                    <button onClick={() => { setIsRegister(!isRegister); setError(''); }} className="text-cyan-400 hover:underline ml-1 font-semibold">
                        {isRegister ? 'Login di sini' : 'Daftar di sini'}
                    </button>
                </p>
            </div>
        </div>
    );
}

// === Halaman Setup Awal untuk User Baru ===
function SetupScreen({ user, onSetupComplete }) {
    const [tokos, setTokos] = useState([]);
    const [selectedTokoIds, setSelectedTokoIds] = useState(new Set());

    useEffect(() => {
        const unsubscribe = db.collection('tokos').onSnapshot(snapshot => {
            setTokos(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
        return () => unsubscribe();
    }, []);

    const handleToggleToko = (tokoId) => {
        const newSelection = new Set(selectedTokoIds);
        if (newSelection.has(tokoId)) {
            newSelection.delete(tokoId);
        } else {
            newSelection.add(tokoId);
        }
        setSelectedTokoIds(newSelection);
    };

    const handleSave = async () => {
        if (selectedTokoIds.size === 0) {
            alert('Harap pilih minimal satu toko untuk dikelola.');
            return;
        }
        try {
            const updatedData = {
                managedTokoIds: Array.from(selectedTokoIds),
                isSetupComplete: true,
            };
            
            await db.collection('users').doc(user.uid).set(updatedData, { merge: true });
            onSetupComplete(updatedData);

        } catch (error) {
            console.error("Gagal menyimpan pengaturan: ", error);
            alert("Terjadi kesalahan saat menyimpan pengaturan.");
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 flex flex-col justify-center items-center p-4">
            <div className="w-full max-w-2xl bg-gray-800 p-8 rounded-lg shadow-lg">
                <h1 className="text-3xl font-bold text-cyan-400 mb-2 text-center">Selamat Datang!</h1>
                <p className="text-gray-400 text-center mb-6">Pilih toko yang akan Anda kelola. Anda hanya akan melihat data dari toko yang Anda pilih.</p>
                
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 mb-8 max-h-64 overflow-y-auto p-4 bg-gray-900 rounded-lg">
                    {tokos.map(toko => (
                        <label key={toko.id} className="flex items-center space-x-3 p-3 bg-gray-700 rounded-lg cursor-pointer hover:bg-gray-600 transition-colors">
                            <input 
                                type="checkbox" 
                                checked={selectedTokoIds.has(toko.id)} 
                                onChange={() => handleToggleToko(toko.id)}
                                className="h-5 w-5 rounded bg-gray-800 border-gray-600 text-cyan-500 focus:ring-cyan-600"
                            />
                            <span className="text-white font-medium">{toko.name}</span>
                        </label>
                    ))}
                </div>

                <button onClick={handleSave} className="w-full bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-4 rounded-lg transition-colors text-lg">
                    Simpan dan Lanjutkan
                </button>
            </div>
        </div>
    );
}

// === Dashboard Utama Aplikasi ===
function Dashboard({ user, userProfile }) {
    const [tokos, setTokos] = useState([]);
    const [transaksis, setTransaksis] = useState([]);
    const [loadingData, setLoadingData] = useState(true);
    const [isTokoModalOpen, setTokoModalOpen] = useState(false);
    const [isTransaksiModalOpen, setTransaksiModalOpen] = useState(false);
    const [selectedTokoId, setSelectedTokoId] = useState('all');

    useEffect(() => {
        setLoadingData(true);
        const unsubscribeTokos = db.collection("tokos").onSnapshot((querySnapshot) => {
            setTokos(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });

        const unsubscribeTransaksis = db.collection("transaksis").orderBy("timestamp", "desc").onSnapshot((querySnapshot) => {
            setTransaksis(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
            setLoadingData(false); // Data is ready
        });

        return () => {
            unsubscribeTokos();
            unsubscribeTransaksis();
        };
    }, []);

    const visibleTransaksis = useMemo(() => {
        if (userProfile.role === 'superadmin') return transaksis;
        return transaksis.filter(tr => userProfile.managedTokoIds.includes(tr.fromId) || userProfile.managedTokoIds.includes(tr.toId));
    }, [transaksis, userProfile]);

     const visibleTokos = useMemo(() => {
        if (userProfile.role === 'superadmin') return tokos;
        return tokos.filter(toko => userProfile.managedTokoIds.includes(toko.id));
    }, [tokos, userProfile]);

    const handleAddToko = async (namaToko) => {
        if (namaToko && !tokos.find(t => t.name === namaToko)) {
            await db.collection("tokos").add({ name: namaToko });
            setTokoModalOpen(false);
        } else {
            alert("Nama toko tidak boleh kosong atau sudah ada.");
        }
    };

    const handleAddTransaksi = async (transaksi) => {
        await db.collection("transaksis").add({
            ...transaksi, amount: Number(transaksi.amount),
            date: new Date().toISOString().split('T')[0],
            timestamp: new Date().toISOString()
        });
        setTransaksiModalOpen(false);
    };

    const dashboardData = useMemo(() => {
        if (loadingData) return { jumlahToko: 0, totalUtangBeredar: 0 };
        const totalUtang = visibleTransaksis.reduce((acc, tr) => tr.type === 'UTANG' ? acc + (tr.amount || 0) : acc, 0);
        const totalBayar = visibleTransaksis.reduce((acc, tr) => tr.type === 'BAYAR' ? acc + (tr.amount || 0) : acc, 0);
        return {
            jumlahToko: userProfile.role === 'superadmin' ? tokos.length : visibleTokos.length,
            totalUtangBeredar: totalUtang - totalBayar,
        };
    }, [loadingData, tokos, visibleTokos, visibleTransaksis, userProfile]);

    const saldoToko = useMemo(() => {
        if (loadingData) return [];
        const balances = {};
        const targetTokos = userProfile.role === 'superadmin' ? tokos : visibleTokos;
        targetTokos.forEach(toko => {
            balances[toko.id] = { utang: 0, piutang: 0, name: toko.name };
        });
        visibleTransaksis.forEach(tr => {
            const amount = tr.amount || 0;
            if (tr.type === 'UTANG') {
                if (balances[tr.fromId]) balances[tr.fromId].utang += amount;
                if (balances[tr.toId]) balances[tr.toId].piutang += amount;
            } else if (tr.type === 'BAYAR') {
                if (balances[tr.fromId]) balances[tr.fromId].utang -= amount;
                if (balances[tr.toId]) balances[tr.toId].piutang -= amount;
            }
        });
        return Object.values(balances);
    }, [loadingData, tokos, visibleTokos, visibleTransaksis, userProfile]);

    const filteredTransaksis = useMemo(() => {
        if (selectedTokoId === 'all') return visibleTransaksis;
        return visibleTransaksis.filter(tr => tr.fromId === selectedTokoId || tr.toId === selectedTokoId);
    }, [visibleTransaksis, selectedTokoId]);

    const getTokoName = (id) => tokos.find(t => t.id === id)?.name || '...';
    
    if (loadingData) {
        return (
            <div className="min-h-screen bg-gray-900 flex justify-center items-center text-white">
                <p>Memuat data dasbor...</p>
            </div>
        );
    }
    
    return (
         <div className="bg-gray-900 min-h-screen text-white font-sans">
            <div className="container mx-auto p-4 md:p-8">
                <header className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
                    <div>
                        <h1 className="text-3xl font-bold text-cyan-400">Aplikasi Pencatatan Utang</h1>
                        <p className="text-gray-400">Login sebagai: {user.email} ({userProfile.role})</p>
                    </div>
                    <div className="flex items-center space-x-2 mt-4 sm:mt-0">
                        {userProfile.role === 'superadmin' && (
                            <button onClick={() => setTokoModalOpen(true)} className="bg-indigo-500 hover:bg-indigo-600 px-4 py-2 rounded-lg flex items-center transition-colors">
                                <PlusIcon /> Tambah Toko
                            </button>
                        )}
                        <button onClick={() => setTransaksiModalOpen(true)} className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded-lg flex items-center transition-colors">
                            <PlusIcon /> Catat Transaksi
                        </button>
                        <button onClick={() => auth.signOut()} className="bg-red-500 hover:bg-red-600 px-4 py-2 rounded-lg flex items-center transition-colors">
                            <LogoutIcon /> Logout
                        </button>
                    </div>
                </header>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    <DashboardCard title="Total Toko Terdaftar" icon={<UserGroupIcon />}>
                        <p className="text-3xl font-semibold">{dashboardData.jumlahToko}</p>
                    </DashboardCard>
                    <DashboardCard title="Total Utang Beredar" icon={<CurrencyDollarIcon />}>
                        <p className="text-3xl font-semibold">Rp {dashboardData.totalUtangBeredar.toLocaleString('id-ID')}</p>
                    </DashboardCard>
                </div>

                <div className="bg-gray-800 p-6 rounded-lg mb-8">
                    <h2 className="text-xl font-bold mb-4 text-cyan-300">Ringkasan Saldo Toko</h2>
                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead>
                                <tr className="border-b border-gray-600">
                                    <th className="p-3">Nama Toko</th>
                                    <th className="p-3">Total Utang (Harus Dibayar)</th>
                                    <th className="p-3">Total Piutang (Akan Diterima)</th>
                                    <th className="p-3">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {saldoToko.map(s => (
                                    <tr key={s.name} className="border-b border-gray-700 hover:bg-gray-700/50">
                                        <td className="p-3 font-medium">{s.name}</td>
                                        <td className="p-3 text-red-400">Rp {s.utang > 0 ? s.utang.toLocaleString('id-ID') : 0}</td>
                                        <td className="p-3 text-green-400">Rp {s.piutang > 0 ? s.piutang.toLocaleString('id-ID') : 0}</td>
                                        <td className="p-3">
                                            <span className={`px-2 py-1 text-xs rounded-full ${s.piutang > s.utang ? 'bg-green-500/20 text-green-300' : 'bg-red-500/20 text-red-300'}`}>
                                                {s.piutang > s.utang ? 'Piutang > Utang' : 'Utang > Piutang'}
                                            </span>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="bg-gray-800 p-6 rounded-lg">
                    <h2 className="text-xl font-bold mb-4 text-cyan-300">Riwayat Transaksi</h2>
                    <div className="flex flex-wrap gap-2 mb-4">
                        <button onClick={() => setSelectedTokoId('all')} className={`px-3 py-1 rounded-full text-sm ${selectedTokoId === 'all' ? 'bg-cyan-500 text-white' : 'bg-gray-700 hover:bg-gray-600'}`}>
                            Semua Toko
                        </button>
                        {visibleTokos.map(toko => (
                            <button key={toko.id} onClick={() => setSelectedTokoId(toko.id)} className={`px-3 py-1 rounded-full text-sm ${selectedTokoId === toko.id ? 'bg-cyan-500 text-white' : 'bg-gray-700 hover:bg-gray-600'}`}>
                                {toko.name}
                            </button>
                        ))}
                    </div>

                    <div className="space-y-3">
                        {filteredTransaksis.length > 0 ? filteredTransaksis.map(tr => (
                        <div key={tr.id} className="bg-gray-700/50 p-4 rounded-lg flex flex-col md:flex-row justify-between items-start md:items-center">
                            <div className="flex-1 mb-2 md:mb-0">
                            <div className="flex items-center font-bold text-lg">
                                <span>{getTokoName(tr.fromId)}</span>
                                <ArrowRightIcon />
                                <span>{getTokoName(tr.toId)}</span>
                            </div>
                            <p className="text-sm text-gray-400">{tr.description}</p>
                            </div>
                            <div className="flex items-center">
                            <span className={`font-semibold text-lg mr-4 ${tr.type === 'UTANG' ? 'text-red-400' : 'text-green-400'}`}>
                                {tr.type === 'BAYAR' ? '+' : '-'} Rp {(tr.amount || 0).toLocaleString('id-ID')}
                            </span>
                            <div className="text-right">
                                <span className="text-xs text-gray-400 block">{tr.date}</span>
                                <span className="text-xs text-gray-500 block">
                                    {tr.timestamp ? new Date(tr.timestamp).toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit', hour12: false }) : ''}
                                </span>
                            </div>
                            </div>
                        </div>
                        )) : <p className="text-center text-gray-500 py-4">Tidak ada transaksi untuk ditampilkan.</p>}
                    </div>
                </div>
            </div>

            <AddTokoModal isOpen={isTokoModalOpen} onClose={() => setTokoModalOpen(false)} onSave={handleAddToko} />
            <AddTransaksiModal isOpen={isTransaksiModalOpen} onClose={() => setTransaksiModalOpen(false)} onSave={handleAddTransaksi} tokos={tokos} />
         </div>
    );
}

function DashboardCard({ title, icon, children }) {
    return (<div className="bg-gray-800 p-6 rounded-lg flex items-center space-x-4"><div className="bg-gray-700 p-3 rounded-full">{icon}</div><div><h3 className="text-gray-400 text-sm font-medium">{title}</h3>{children}</div></div>);
}
function AddTokoModal({ isOpen, onClose, onSave }) {
    const [namaToko, setNamaToko] = useState(''); if (!isOpen) return null; const handleSubmit = (e) => { e.preventDefault(); onSave(namaToko); setNamaToko(''); }
    return (<div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"><div className="bg-gray-800 p-8 rounded-lg w-full max-w-md m-4"><h2 className="text-2xl font-bold mb-6">Tambah Toko Baru</h2><form onSubmit={handleSubmit}><div className="mb-4"><label htmlFor="namaToko" className="block text-gray-400 mb-2">Nama Toko</label><input type="text" id="namaToko" value={namaToko} onChange={(e) => setNamaToko(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" required /></div><div className="flex justify-end space-x-3 mt-8"><button type="button" onClick={onClose} className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-lg transition-colors">Batal</button><button type="submit" className="bg-indigo-500 hover:bg-indigo-600 px-4 py-2 rounded-lg transition-colors">Simpan</button></div></form></div></div>);
}
function AddTransaksiModal({ isOpen, onClose, onSave, tokos }) {
    const [fromId, setFromId] = useState(''); const [toId, setToId] = useState(''); const [amount, setAmount] = useState(''); const [description, setDescription] = useState(''); const [type, setType] = useState('UTANG'); const [error, setError] = useState(''); if (!isOpen) return null; const handleSubmit = (e) => { e.preventDefault(); if (fromId === toId) { setError('Toko pemberi dan penerima tidak boleh sama.'); return; } if (!fromId || !toId || !amount) { setError('Harap isi semua kolom yang wajib.'); return; } setError(''); onSave({ fromId, toId, amount: Number(amount), description, type }); setFromId(''); setToId(''); setAmount(''); setDescription(''); setType('UTANG'); };
    return (<div className="fixed inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"><div className="bg-gray-800 p-8 rounded-lg w-full max-w-lg m-4"><h2 className="text-2xl font-bold mb-6">Catat Transaksi Baru</h2>{error && <p className="bg-red-500/20 text-red-300 p-3 rounded-lg mb-4">{error}</p>}<form onSubmit={handleSubmit}><div className="mb-4"><label className="block text-gray-400 mb-2">Jenis Transaksi</label><div className="flex rounded-lg bg-gray-700 p-1"><button type="button" onClick={() => setType('UTANG')} className={`w-1/2 py-2 rounded-md transition-colors ${type === 'UTANG' ? 'bg-red-500' : 'hover:bg-gray-600'}`}>Utang Baru</button><button type="button" onClick={() => setType('BAYAR')} className={`w-1/2 py-2 rounded-md transition-colors ${type === 'BAYAR' ? 'bg-green-500' : 'hover:bg-gray-600'}`}>Pembayaran</button></div></div><div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4"><div><label htmlFor="fromId" className="block text-gray-400 mb-2">{type === 'UTANG' ? 'Toko yang Berhutang' : 'Toko yang Membayar'}</label><select id="fromId" value={fromId} onChange={e => setFromId(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" required><option value="" disabled>Pilih Toko</option>{tokos.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}</select></div><div><label htmlFor="toId" className="block text-gray-400 mb-2">{type === 'UTANG' ? 'Toko Pemberi Utang' : 'Toko Penerima Bayaran'}</label><select id="toId" value={toId} onChange={e => setToId(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" required><option value="" disabled>Pilih Toko</option>{tokos.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}</select></div></div><div className="mb-4"><label htmlFor="amount" className="block text-gray-400 mb-2">Jumlah (Rp)</label><input type="number" id="amount" value={amount} onChange={e => setAmount(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" required min="1" /></div><div className="mb-4"><label htmlFor="description" className="block text-gray-400 mb-2">Deskripsi (Opsional)</label><textarea id="description" value={description} onChange={e => setDescription(e.target.value)} className="w-full bg-gray-700 border border-gray-600 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-cyan-500" rows="2"></textarea></div><div className="flex justify-end space-x-3 mt-8"><button type="button" onClick={onClose} className="bg-gray-600 hover:bg-gray-500 px-4 py-2 rounded-lg transition-colors">Batal</button><button type="submit" className="bg-green-500 hover:bg-green-600 px-4 py-2 rounded-lg transition-colors">Simpan Transaksi</button></div></form></div></div>);
}

export default App;
